import { RequestState } from '../../../types'

export type AddressSettingsState = {
  timezones: Timezone[]
  timezonesRequestState: RequestState
  countries: Country[]
  countriesRequestState: RequestState
  addressRequestState: RequestState
  address: Address
  noAddress: boolean
  updateRequestState: RequestState
}

export type Timezone = {
  id: string
  name: string
  offset: string
}

export type Country = {
  id: string
  name: string
}

export type Address = {
  id: string
  businessName: string
  addressLine1: string
  addressLine2: string
  city: string
  postcode: string
  region: string
  country?: string
}

export const emptyAddress = {
  id: '',
  businessName: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  region: '',
  postcode: ''
}

export const initialAddressSettingsState: AddressSettingsState = {
  timezones: [],
  timezonesRequestState: RequestState.NotLoaded,
  countries: [],
  countriesRequestState: RequestState.NotLoaded,
  addressRequestState: RequestState.NotLoaded,
  address: emptyAddress,
  noAddress: true,
  updateRequestState: RequestState.NotLoaded
}
